import { jsx as _jsx } from "react/jsx-runtime";
import { Outlet } from 'react-router-dom';
export const PublicLayout = () => {
    return _jsx(Outlet, {});
};
